$(() => {
    const $wrapper = $('#recommender-override-wrapper');
    const $modal = $('#recommender-override-modal');
    const $form = $('form#recommender-override');
    const $filterBtn = $('#recommender-override-btn');
    const $searchAjax = $('#override_preferred_destinations');
    const $specialty = $('select[name="override[specialty]"]');
    const $license = $('select[name="override[license]"]');

    if ($searchAjax.length) {
        initializeDestinationSearch();
    }

    $filterBtn.on('click', function() {
        submitOverrides();
    });

    $(document).on('change', 'form#recommender-override', function() {
        $filterBtn.prop('disabled', false);
    });

    /**
     * This event is fired when the recommender is initialized during the funnel.
     * This allows us to set up the appropriate field/values based on the information
     * the user entered in the MVI step.
     */
    $(document).on('job-recommender-override:init', function(event) {
        const { license, specialty, specialtyList, destinations } = event.detail;

        initializeDestinationSearch(destinations);

        if ($specialty.length && specialtyList) {
            $specialty.children('option').remove();
            addOptionsToSelect2($specialty, specialtyList);
            $specialty.val(specialty).trigger('change');
        }

        if ($license.length && license) {
            $license.val(license).trigger('change');
        }
    });

    /**
     * @param {object} [values]
     */
    function initializeDestinationSearch(values) {
        if ($searchAjax.length) {
            $searchAjax.select2({
                minimumInputLength: 2,
                ajax: {
                    url: $searchAjax.data('source'),
                    dataType: 'json',
                    delay: 400,
                },
                placeholder: $searchAjax.attr('placeholder'),
                dropdownParent: $('#recommender-override-modal'),
            });

            const initialValues = values || $searchAjax.data('value');

            if (initialValues) {
                $searchAjax.children('option').remove();
                addOptionsToSelect2($searchAjax, initialValues);
            }
        }
    }

    /**
     * @param {JQuery} jqElement
     * @param {object} values
     */
    function addOptionsToSelect2(jqElement, values) {
        for (const [key, value] of Object.entries(values)) {
            jqElement.append(new Option(
                value,
                key,
                true,
                true,
            ));
        }
    }

    function submitOverrides() {
        const data = new FormData($form.get(0));

        const event = new CustomEvent('job-recommender:override-jobs',
            {
                bubbles: true,
                detail: {
                    destinations: data.getAll('override[destinations][]'),
                    license: data.get('override[license]'),
                    specialty: data.get('override[specialty]'),
                },
            },
        );

        $wrapper.get(0).dispatchEvent(event);

        $filterBtn.prop('disabled', true);

        $modal.modal('hide');
    }
});
